import React, { useMemo, useEffect, useRef, useCallback } from "react"
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import * as actions from "../../_redux/reporting/assets/assetsActions"
import { useUIContext } from "../UIContext"
// import TimesheetDailyToPrint from "./Charts/TimesheetDailyToPrint/TimesheetDailyToPrint"
import { debounce } from "lodash"
import { AttendanceByAssetType } from "./Charts/AttendanceByAssetType"
import { TimesheetPerTypeAsset } from "./Charts/TimesheetPerTypeAsset"
import { TimesheetDailyAssets } from "./Charts/TimesheetDailyAssets"

export function AssetsTimesheetPage() {
	const dispatch = useDispatch()

	const UIContext = useUIContext()
	const UIProps = useMemo(() => {
		return {
			queryParams: UIContext.queryParams,
			setQueryParams: UIContext.setQueryParams
		}
	}, [UIContext])

	const { group, customer, selectedSite, siteId, people, roles, vendors, assets } = useSelector(
		state => ({
			group: state.persistentReporting?.group,
			customer: state.profile?.currentCustomer,
			selectedSite: state.profile?.currentSite,
			siteId: state.profile?.currentSite?.id,
			people: state.basePage?.people || [],
			roles: state.profile?.currentCustomer?.roles,
			vendors: state.profile?.currentCustomer?.vendors,
			assets: state.basePage.assets
		}),
		shallowEqual
	)

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const fetchSummary = useCallback(
		debounce(() => {
			if (!customer || !selectedSite) return

			dispatch(
				actions.fetchAssetsTimesheet({
					customerId: customer.id,
					siteId,
					selectedSite,
					people: people,
					assets,
					vendors: vendors,
					nodeType: "assets",
					...UIProps.queryParams
				})
			)
		}, 300), // Adjust the debounce delay as needed
		[customer, UIProps.queryParams, selectedSite, siteId, people, assets, vendors]
	)

	useEffect(() => {
		fetchSummary()

		// Cleanup the debounce on component unmount
		return () => {
			fetchSummary.cancel()
		}
	}, [fetchSummary])

	const componentRef = useRef()

	return (
		<div className="row" id="people_timesheet_main_div">
			<>
				<div className="col-12">
					<AttendanceByAssetType />
				</div>
				<div className="col-12">
					<TimesheetPerTypeAsset />
				</div>
				<div className="col-12">
					<TimesheetDailyAssets
					// ref={componentRef}
					/>
				</div>
				<div className="col-12" style={{ overflow: "hidden", height: "0" }}>
					{/* <TimesheetDailyToPrint ref={componentRef} /> */}
				</div>
			</>
		</div>
	)
}
